import React from "react";

// =============================================================================
// HeroBackground — shared looping ABC Plumbing van video background used by
// every hero that wants the same brand backdrop (Home, ServiceDetail,
// ServiceAreaDetail).
//
// Why one shared component?
//   1. Browsers cache the MP4 by URL, but reusing the same JSX also means
//      one source of truth for the blur amount, the brand tint, the dark
//      overlay, and the grid pattern. Tweak it in one place and every hero
//      page picks the change up — no more drift between pages.
//   2. Drops a lot of duplicated `<div className="absolute inset-0 -z-10">`
//      boilerplate from the hero JSX in 3 files.
//
// Layer order (bottom → top, all `absolute inset-0`):
//   • <video> — blurred, slightly scaled to hide the blur edges
//   • abc-hero-overlay — dark navy gradient for text legibility
//   • abc-hero-tint    — brand blue radial tint on top of the navy
//   • abc-grid-pattern — subtle radial dot pattern for texture
// =============================================================================

const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_starter-complete/artifacts/d8rsgwwe_Drain%20Sights%20LLC%20Van%20Video%20for%20Hero.mp4";
// Poster shown for the first frame and while the video downloads.
const HERO_POSTER = "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1800&q=70";

export default function HeroBackground() {
  return (
    <div className="absolute inset-0 -z-10" aria-hidden="true">
      <video
        src={HERO_VIDEO}
        poster={HERO_POSTER}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="w-full h-full object-cover abc-hero-video"
      />
      <div className="absolute inset-0 abc-hero-overlay" />
      <div className="absolute inset-0 abc-hero-tint" />
      <div className="absolute inset-0 abc-grid-pattern opacity-40" />
    </div>
  );
}
